import React, {useState, useCallback} from 'react';
import PropTypes from 'prop-types';
import {Popover} from '@perion-undertone/ut-react-common';

const CLASS_NAMES = {
    AD_UNITS_TOOLTIP_LINK: 'adunits-tooltip-link',
    AD_UNITS_CONTAINER: 'ad-units-container',
    AD_UNITS_CONTENT: 'ad-units-content',
};

const AdUnitsFormatter = ({value}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleTriggerClick = useCallback((event) => {
        event.stopPropagation();
        setIsOpen((prev) => !prev);
    }, []);

    const handleClickOutside = useCallback(() => {
        setIsOpen(false);
    }, []);

    const stopGridEvent = useCallback((event) => {
        event.stopPropagation();
    }, []);

    const source = typeof value === 'string' ? value.split(',') : value;
    const adunits = Array.isArray(source) ? source : [];
    let [firstUnit, ...otherUnits] = adunits;
    firstUnit = firstUnit || {name: ''};

    if (!otherUnits.length) {
        return <div>{`${firstUnit.name || firstUnit}  `}</div>;
    }

    const trigger = (
        <span className={CLASS_NAMES.AD_UNITS_TOOLTIP_LINK}
              onMouseDown={stopGridEvent}
        >
            {`+${otherUnits.length}`}
        </span>
    );

    return (
        <div>
            {`${firstUnit.name || firstUnit}  `}

            <Popover basic={true}
                     appendToBody={true}
                     open={isOpen}
                     onClick={handleTriggerClick}
                     onClickOutside={handleClickOutside}
                     stopPropagationOnClick={true}
                     trigger={trigger}
                     className={CLASS_NAMES.AD_UNITS_CONTAINER}
                     hookId="ad-units-formatter-popover"
            >
                <div className={CLASS_NAMES.AD_UNITS_CONTENT}>
                    {otherUnits.map((adUnit) => <div key={adUnit.id || adUnit}>{adUnit.name || adUnit}</div>)}
                </div>
            </Popover>
        </div>
    );
};

AdUnitsFormatter.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

export default AdUnitsFormatter;
